<template>
  <div class="socials">
    <button class="social-link" @click="openSocial('http://www.facebook.com/sharer.php?u=https://pickastick.xyz')">
      <img src="/facebook-icon.png" alt="">
    </button>
    <button class="social-link" @click="openSocial('https://twitter.com/intent/tweet?text=pickastick.xyz')">
      <img src="/twitter-icon.png" alt="">
    </button>
    <button class="social-link" @click="openSocial('http://pinterest.com/pin/create/button/?url=https://pickastick.xyz')">
      <img src="/pintrest-icon.png" alt="">
    </button>
    <button class="social-link" @click="openSocial('http://www.linkedin.com/shareArticle?mini=true&url=https://pickastick.xyz')">
      <img src="/linkedin-icon.png" alt="">
    </button>
  </div>
</template>


<script>
export default {
  name:"Socials",
  methods: {
    openSocial(link){
      window.open(link,"Share Pick A Stick", "height=400,width=600")
    }
  },
}
</script>


<style lang="scss">
  .socials{
    position: static;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto;
    

    .social-link{
      width: 100%;
      max-width: 50px;
      margin: 0 10px;
      padding: 0;
      background: none;
      border: none;
      box-shadow: none;

      img{
        filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
        max-width: 100%;
      }
    }

    @media (min-width: 500px){
      position: fixed;
      left: 15px;
      top: 15px;
      width: 50px;
      display: block;

      .social-link{
        margin: 0;
        transition: all 250ms;
        display: block;

        &:hover{
          transform: scale(1.2);
        }
      }
    }
  }
</style>